import tw from 'tailwind-styled-components'

export const ModalContent = tw.div`
  min-h-300
  flex flex-col
  justify-center
  items-center
  text-center
  gap-30
  p-30
`

export const ModalHeading = tw.h3`
  text-yellow
  text-2xl
  font-extrabold
  text-center
  leading-6
  py-3
`

export const ModalText = tw.p`
  text-sm
  text-eucalyptus
`

export const ModalLink = tw.span`
  text-pink
  cursor-pointer
`

export const ModalExtendedInfo = tw.p`
  text-sm
  text-eucalyptus
  text-left
`